import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources";
import Document from "../../model2/doc/document"

export default class DocumentsResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, Document, options)
    }
}